export default {
	fill_form_with_data_of_whom_you_recommend_and_we_will_contact_you: "Ұсынатын адамның деректері бар нысанды толтырыңыз, біз Сізбен байланысамыз:",
	fill_form_yourself: "Нысанды жеке толтырыңыз!",
	how_referral_system_works: 'Рефералдық жүйе қалай жұмыс істейді?',
	immediately_after_first_payment_of_your_referral: "Сіздің рефералыңыздың бірінші төлемінен кейін бірден",
	let_your_friend_scan_qr: "QR кодын досыңызға сканерлеуге рұқсат етіңіз",
	let_your_friend_scan_qr_below: "QR кодын төменде досыңызға сканерлеуге рұқсат етіңіз",
	or: "немесе",
	receive_payment_from_our_manager_on_your_card: "Сіздің картаңызға біздің менеджерден төлем алыңыз.",
	receive_reward_for_first_payment: "Алыңыз <span class='text-primary'>{reward}</span> {currency} сіздің рефералыңыздың бірінші төлемі үшін.",
	recommend_dentist_plus_to_your_friends: "Серіктестік бағдарлама арқылы таныстарыңызға Dentist+ ұсыныңыз және сыйақы алыңыз:",
	recommend_dentist_plus_to_your_friends_with_any_method: "Кез келген таңдау тәсілінің көмегімен Dentist+ бағдарламасын таныстарыңызға ұсыныңыз:",
	referral_system_for_users: 'Пайдаланушыларға арналған рефералдық жүйе',
	start_earning_right_now: 'Қазір ақша табуды бастаңыз!'
}

